var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.125 15H0.21875V5.65625H3.125V15ZM1.65625 4.40625C0.75 4.40625 0 3.625 0 2.6875C0 1.40625 1.375 0.59375 2.5 1.25C3.03125 1.53125 3.34375 2.09375 3.34375 2.6875C3.34375 3.625 2.59375 4.40625 1.65625 4.40625ZM13.9688 15H11.0938V10.4688C11.0938 9.375 11.0625 8 9.5625 8C8.0625 8 7.84375 9.15625 7.84375 10.375V15H4.9375V5.65625H7.71875V6.9375H7.75C8.15625 6.21875 9.09375 5.4375 10.5 5.4375C13.4375 5.4375 14 7.375 14 9.875V15H13.9688Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.6fffeffbe9907351ff209a212eccd76a.svg";
export { ForwardRef as ReactComponent };